module.exports = __webpack_public_path__ + "static/media/ArrowDownNew.a3855ace.svg";